// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1229":"227cd318","5709":"0d0dcb5a","7031":"ea3987cf","9870":"227cd318"}[chunkId] + ".chunk.css";
};